import { ComplianceCaseTypeEnum as ComplianceCaseType } from "../../../graphql/supergraphTypes";
import { isJoinAccountType } from "../../../utils/account_types";
import {
  CompletionDocumentStatus,
  RootProfileConfig,
  ProfileTypeForStatus,
} from "../../common/ProfileManagement/types";
import {
  isProfileCompleted,
  type ProfileCompletionSnapshot,
} from "../../ProfileActionOverview/utils";
import { ProfileStatus } from "../../ProfileStatusBadge/types";

export const getProfileStatus = (
  caseType: ComplianceCaseType,
  rootProfile: RootProfileConfig,
  completionStatus: ProfileCompletionSnapshot,
  profile?: ProfileTypeForStatus | null,
  programId?: number,
) => {
  const isCompleted = isProfileCompleted(
    caseType,
    rootProfile,
    profile,
    programId,
    completionStatus,
  );

  if (isCompleted) {
    return ProfileStatus.Completed;
  }

  const isJointAccount = isJoinAccountType(profile?.accountType);
  const childOwnersCount = profile?.childOwnersCount ?? 0;

  if (isJointAccount && childOwnersCount < 2) {
    const hasAddedAtLeastOneOwner = childOwnersCount >= 1;
    if (!hasAddedAtLeastOneOwner) {
      return ProfileStatus.NotStarted;
    }
    return ProfileStatus.UpdateRequired;
  }

  if (completionStatus.documentsCompletionStatus === CompletionDocumentStatus.EXPIRED) {
    return ProfileStatus.UpdateRequired;
  }

  const caseDataEntryStatus = profile?.caseDataEntryStatus;

  const hasDocumentsCompleted = caseDataEntryStatus?.documentsCompleted === true;
  const hasOwnersCompleted =
    caseDataEntryStatus?.ownersCompleted === true ||
    caseDataEntryStatus?.ownersCompleted === null;
  const hasControllersCompleted =
    caseDataEntryStatus?.controllersCompleted === true ||
    caseDataEntryStatus?.controllersCompleted === null;

  const hasAnyCompleted =
    hasDocumentsCompleted || hasOwnersCompleted || hasControllersCompleted;

  return hasAnyCompleted ? ProfileStatus.InProgress : ProfileStatus.NotStarted;
};
